import { useCallback, useContext, useRef, useState } from 'react';
import { unFollow, follow } from '@/services/follow';
import { WalletContext } from '@/contexts/wallet-context';
import s from './style.module.scss';
import { IconFollow } from '../Icon/IconFollow';
import { IconUnfollow } from '../Icon/IconUnfollow';
import { toast } from 'react-hot-toast';
import { PostItemContext } from '@/contexts/post-item';

export function ButtonFollow({
  twitter_id,
  twitter_name,
  className = '',
  isFollowed,
  setIsFollowed,
  onClose,
}: {
  twitter_id: string;
  twitter_name: string;
  className?: string;
  onClose?: () => void;
  isFollowed: boolean | undefined;
  setIsFollowed: (b: boolean | undefined) => void;
}) {
  const { addressL2 } = useContext(WalletContext);
  const { setIsFollowUseOfPost } = useContext(PostItemContext);

  const refTarget = useRef(null);
  const [isSending, setIsSending] = useState<boolean>(false);

  const callAction = useCallback(async () => {
    if (!addressL2 || isSending) return;
    setIsSending(true);
    if (!isFollowed) {
      await follow({ address: addressL2, to_twitter_id: twitter_id });
      setIsFollowed(true);
      // toast.success(`You are following ${twitter_name}.`);
    } else {
      await unFollow({ address: addressL2, to_twitter_id: twitter_id });
      // toast.success(`You unfollowed ${twitter_name}.`);
      setIsFollowed(false);
    }
    onClose && onClose();
    setIsSending(false);
  }, [isFollowed, addressL2, twitter_id, isSending]);

  return (
    <>
      <div
        ref={refTarget}
        className={`${s.btnFollow} ${className}`}
        onClick={e => {
          e.stopPropagation();
          callAction();
        }}
      >
        <>
          {!isFollowed && (
            <>
              <IconFollow />
              <span>{isSending ? 'Processing' : 'Follow'}</span>
            </>
          )}
          {isFollowed && (
            <>
              <IconUnfollow />
              <span>{isSending ? 'Processing' : 'Unfollow'}</span>
            </>
          )}
        </>
      </div>
    </>
  );
}
